export const regex = /^(?=.*[A-Z])(?=.*[\W_]).{8,}$/;
